// extracted by mini-css-extract-plugin
module.exports = {"footerFixed":"Footer_footerFixed__2W-XR","footer":"Footer_footer__3nw2l","text":"Footer_text__6y2TH","link":"Footer_link__1N7ua"};